import { useMemo } from 'react';

import { useMediaQuery, useTheme } from '@mui/material';

export default function useResponsive() {
    const { breakpoints } = useTheme();
    const isMobile = useMediaQuery(breakpoints.down(breakpoints.values.tablet));
    const isTablet = useMediaQuery(
        `${breakpoints.between(breakpoints.values.tablet, breakpoints.values.desktop)}`
    );
    const isDesktop = useMediaQuery(breakpoints.up(breakpoints.values.desktop));

    return useMemo(() => ({ isMobile, isTablet, isDesktop }), [isMobile, isTablet, isDesktop]);
}
